var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.04297 8.74935C1.04297 4.49217 4.49412 1.04102 8.7513 1.04102C13.0085 1.04102 16.4596 4.49217 16.4596 8.74935C16.4596 10.6529 15.7696 12.3954 14.626 13.7402L17.8212 16.9354C18.0653 17.1795 18.0653 17.5752 17.8212 17.8193C17.5772 18.0634 17.1814 18.0634 16.9373 17.8193L13.7421 14.6241C12.3973 15.7676 10.6549 16.4577 8.7513 16.4577C4.49412 16.4577 1.04297 13.0065 1.04297 8.74935ZM8.7513 2.29102C5.18448 2.29102 2.29297 5.18253 2.29297 8.74935C2.29297 12.3162 5.18448 15.2077 8.7513 15.2077C12.3181 15.2077 15.2096 12.3162 15.2096 8.74935C15.2096 5.18253 12.3181 2.29102 8.7513 2.29102ZM5.9526 5.53433C6.66827 4.81872 7.6587 4.375 8.75157 4.375C9.84444 4.375 10.8349 4.81872 11.5505 5.53435C11.7946 5.77843 11.7946 6.17416 11.5505 6.41823C11.3064 6.66231 10.9107 6.66231 10.6666 6.41823C10.1758 5.92745 9.49962 5.625 8.75157 5.625C8.00353 5.625 7.32729 5.92745 6.83646 6.41825C6.59237 6.66232 6.19664 6.6623 5.95257 6.41822C5.70851 6.17413 5.70852 5.7784 5.9526 5.53433Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchWhite);
export default __webpack_public_path__ + "static/media/Search-white.6e568434.svg";
export { ForwardRef as ReactComponent };